import Swiper from 'swiper';
import { Pagination, Navigation } from 'swiper/modules';

const ExpertEndorsement = {
  init() {
    const section = document.querySelector('.expert-endorsement');
    if (!section) return;

    new Swiper('.expert-endorsement__swiper', {
        slidesPerView: 1,
        loop: true,
        modules: [Pagination, Navigation],
        pagination: {
            el: '.expert-endorsement__tabs',
            clickable: true,
            renderBullet: function (index, className) {
                const blocks = document.querySelectorAll('.swiper-slide .expert-slide__name');
                return `<span class="${className}">${blocks[index].textContent}</span>`;
            },
        },
        navigation: {
            nextEl: '.expert-button-next',
            prevEl: '.expert-button-prev',
        },
    });
  }
};

export default ExpertEndorsement;
